import p from 'x/config/platform-specific'

const ImgManager = p.comp.getImgManager()

export default ImgManager
